import {
  HappyHourData,
  HappyHourMessagesByLocation,
  HappyHourMessage,
} from "../types/HappyHour.interface";
import { useMemo } from "react";
import { isHappyHourMessageVisible } from "../utils/isHappyHourMessageVisible";
import useCustomerModelChange from "@src/backbone/hooks/useCustomerModelChange";

/**
 * Hook pour filtrer les messages Happy Hour visibles par location
 * et retourner celui avec la priorité la plus haute (plus petit priority)
 */
export function useHappyHourVisibility(
  messages: HappyHourData
): HappyHourMessagesByLocation {
  const [customerData, customer] = useCustomerModelChange([
    "id_customer",
    "segmentation",
    "groups",
  ]);

  const filtered: HappyHourMessagesByLocation = useMemo(() => {
    const filtered: HappyHourMessagesByLocation = {};
    for (const location in messages) {
      const msg = messages[location as keyof HappyHourData] as
        | HappyHourMessage
        | undefined;
      if (!msg) {
        filtered[location as keyof HappyHourMessagesByLocation] = undefined;
        continue;
      }
      // Filtrer les messages visibles
      const visible = isHappyHourMessageVisible(msg);
      if (!visible) {
        filtered[location as keyof HappyHourMessagesByLocation] = undefined;
        continue;
      }
      filtered[location as keyof HappyHourMessagesByLocation] = msg;
    }
    return filtered;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerData, customer, messages]);

  return filtered;
}
